module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Light.29e25ce5.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/BasisGrotesquePro-Light.ttf
// module id = 626
// module chunks = 168707334958949